module.exports = __webpack_public_path__ + "media/images/element/17-8f8501bf5080b7ef4e15b1a6af48fe19.svg";